import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}